import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  InvitationTemplateResponse,
  InvitationTemplateRequest,
  InvitationTemplatePageResponse,
  InvitationTemplatePreviewRequest,
  InvitationTemplatePreviewResponse
} from '../models/invitation-template.model';

@Injectable({
  providedIn: 'root'
})
export class InvitationTemplateApiService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}api`;

  // GET /api/invitation-templates?page=&size=
  list(page = 0, size = 20): Observable<InvitationTemplatePageResponse> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get<InvitationTemplatePageResponse>(`${this.apiUrl}/invitation-templates`, { params });
  }

  // GET /api/invitation-templates/{id}
  getById(id: number): Observable<InvitationTemplateResponse> {
    return this.http.get<InvitationTemplateResponse>(`${this.apiUrl}/invitation-templates/${id}`);
  }

  // POST /api/invitation-templates
  create(request: InvitationTemplateRequest): Observable<InvitationTemplateResponse> {
    return this.http.post<InvitationTemplateResponse>(`${this.apiUrl}/invitation-templates`, request);
  }

  // PUT /api/invitation-templates/{id}
  update(id: number, request: InvitationTemplateRequest): Observable<InvitationTemplateResponse> {
    return this.http.put<InvitationTemplateResponse>(`${this.apiUrl}/invitation-templates/${id}`, request);
  }

  // DELETE /api/invitation-templates/{id}
  deactivate(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/invitation-templates/${id}`);
  }

  // PATCH /api/invitation-templates/{id}/set-default
  setDefault(id: number): Observable<InvitationTemplateResponse> {
    return this.http.patch<InvitationTemplateResponse>(`${this.apiUrl}/invitation-templates/${id}/set-default`, {});
  }

  // POST /api/invitation-templates/preview  — renderer autoritativo (mismo del envío real)
  preview(request: InvitationTemplatePreviewRequest): Observable<InvitationTemplatePreviewResponse> {
    return this.http.post<InvitationTemplatePreviewResponse>(`${this.apiUrl}/invitation-templates/preview`, request);
  }
}
